<template>
  <div>
    <div v-if="trial" class="mb-7">
      <v-card-title class="font-weight-bold pt-2 pb-1 d-flex justify-center" style="text-transform: uppercase;">
        {{ $t('result.motivation.title') }}
      </v-card-title>
      <v-card rounded outlined>
        <!-- ITEM BALANCE -->
        <div class="pa-2 mb-5">
          <item-balance
              :title="itemBalance.title"
              :value="itemBalance.value"
              :stream="isOdlisnostChecked"
          ></item-balance>
        </div>
      </v-card>
    </div>
    <v-card v-else rounded outlined>
      <!-- title -->
      <v-card-title class="pb-0 back_accent">
        {{ $t('result.motivators.title') }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pt-0 back_accent">
        {{$t('result.motivators.text')}}
      </v-card-text>

      <!-- Upgrade result -->
      <div v-if="result_type === 1 && !share && 3 < 2" class="d-print-none d-none">
        <v-alert
            outlined
            prominent
            icon="mdi-arrow-up-bold-box-outline"
            class="back_accent mt-1"
        >
          <v-row align="center">
            <v-col sm="8" cols="12" class="grow caption py-1">
              {{ $t("result.upgrade_text")}}
            </v-col>
            <v-col class="shrink py-1">
              <v-btn color="success" dark small @click="dialogUpgradeResult = true">
                {{$t("result.upgrade_button")}}
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </div>

      <!-- ITEMS TABLE -->
        <v-card-text class="mt-0-print pt-0-print" style="margin-top: 12px; padding-top:16px;">
          <!-- FILTERS -->
          <!-- CATEGORY filter -->
          <v-row justify="space-around" class="d-print-none">
            <div class="px-2">
              <v-chip-group
                  class="align-center text-center d-flex"
                  v-model="group"
                  column
                  multiple
                  active-class="accent--text"
              >
                <v-chip
                    v-for="(grp,gkey, index) in groups"
                    :key="gkey"
                    filter
                    label
                    :value="parseInt(gkey)"
                    outlined
                    :disabled="Object.entries(group_keys).length < 2"
                >
                  {{ grp }}
                </v-chip>
              </v-chip-group>
            </div>
          </v-row>

          <!-- FILTER -->
          <v-row justify="space-around" class="mt-0 d-print-none">
            <div class="pa-2">
              <v-chip-group
                  class="align-center text-center d-flex"
                  v-model="filter"
                  column
                  multiple
                  active-class="accent--text"
              >
                <v-chip
                    v-for="(flt,ftkey,index) in filters"
                    :key="ftkey"
                    :value="parseInt(ftkey)"
                    small
                    filter
                    outlined
                >
                  <v-icon small left color="grey darken-1">{{ flt.icon }}</v-icon> {{ flt.title }}
                </v-chip>
              </v-chip-group>
            </div>
          </v-row>

          <!-- ITEM BALANCE -->
          <div class="pa-2 mb-2">
            <item-balance
                :title="itemBalance.title"
                :value="itemBalance.value"
                :stream="isOdlisnostChecked"
            ></item-balance>
          </div>

          <!-- TERM LIST -->
          <div class="mt-5">
            <v-card class="mb-2 bm-page-break-inside" flat outlined v-for="(tgroup, tgkey) in termsJoined.groups" :key="'terms-'+tgkey">
              <div style="overflow: hidden; position:relative;">
                <div :style="{width:'9px', height: '100%', backgroundColor: colors[tgkey], position: 'absolute', top: 0, left: 0}">
                  &nbsp;
                </div>
                <div style="margin-left: 9px;">
                  <div class="d-flex align-center" style="margin-left:-9px;">
                    <v-btn depressed class="py-3 px-3" x-small dark :color="colors[tgkey]">
                      <v-icon small>mdi-account-reactivate</v-icon>
                    </v-btn>
                    <div class="pl-3">
                      <v-card-title class="subtitle-1 pb-0 pl-0">
                        {{$t("result.motivators.table."+tgkey+".title")}}
                      </v-card-title>
                      <div class="caption mb-2 d-block">{{$t("result.motivators.table."+tgkey+".text")}}</div>
                    </div>
                  </div>
                  <v-card-text class="py-print">
                    <div class="caption mb-2 d-none">{{$t("result.motivators.table."+tgkey+".text")}}</div>
                    <v-chip
                        v-if="(filter.length === 0 || getTermFormat(term, tgkey).filters.filter(value => filter.includes(value)).length > 0) && (group.length === 0 || getTermFormat(term, tgkey).groups.filter(value => group.includes(value)).length > 0)"
                        v-for="(term, tkey) in tgroup"
                        :key="tkey"
                        small
                        class="ma-1"
                        :color="getTermFormat(term, tgkey).color"
                    >
                      <v-sheet v-if="getTermFormat(term, tgkey).difference"
                               style="width:25px; height:100%;margin-right:10px;margin-left:-12px;"
                               :color="getTermFormat(term, tgkey).difference.color">
                        <v-icon
                            left
                            small
                            class="ml-1"
                            dark
                        >
                          {{getTermFormat(term, tgkey).difference.icon}}
                        </v-icon>
                      </v-sheet>
                      <v-icon
                          v-for="(icon, ikey) in getTermFormat(term, tgkey).icons"
                          :key="ikey"
                          left
                          small
                          class="mr-2"
                          :color="icon.color"
                      >
                        {{icon.icon}}
                      </v-icon>
                      {{getTermByLocale(term)}}
                    </v-chip>
                  </v-card-text>
                </div>
              </div>
            </v-card>
          </div>
        </v-card-text>
    </v-card>

    <!-- Upgrade result -->
    <upgrade-result
        v-if="!trial"
        :show-dialog="dialogUpgradeResult"
        :respondent="result"
        v-on:diagClose="dialogUpgradeResult = false"
    ></upgrade-result>

  </div>
</template>

<script>
  import termsByLocale from '../translations/terms.json'
  import ResultUtils from "./resultUtils";
  export default {
    name: "Motivators",
    props: ['result','result_type'],
    components: {
      ItemBalance: () => import('../components/ItemBalance'),
      BallsSummary: () => import('../components/BallsSummary'),
      UpgradeResult: () => import("../components/UpgradeResult"),
    },
    data() {
      return {
        motivators: {},
        dialogUpgradeResult: false,
        filter: [],
        filters: {
          1: {title:this.$t('result.motivators.filter.1'),icon:'mdi-account-reactivate'},
          // 2: {title:this.$t('result.motivators.filter.2'), icon:'mdi-weather-sunny'},
          // 3: {title: this.$t('result.motivators.filter.3'), icon: 'mdi-sawtooth-wave'}
        },
        group: [],
        table_keys: {
          1:'ideals',
          2: 'satisfactors',
          3: 'operators',
          4: 'stresors',
          5: 'destructors'
        },
        group_keys: {
          1: 'work',
          2: 'health',
          3: 'family',
          4: 'custom'
        }
      }
    },
    computed: {
      trial() {
        return this.result.trial;
      },
      fullTrial() {
        return this.$store.getters['auth/trialFull'];
      },
      share() {
        return this.$router.currentRoute.name === 'share'
      },
      shareTopics() {
        return (!this.share || (this.$store.getters['diagnostic/isShared'] && this.$store.getters['diagnostic/shareOptions'].topics));
      },
      groups() {
        let keys =  {
          1: this.$t("result.motivators.groups.1."+this.result.project.type),
          2: this.$t("result.motivators.groups.2"),
          3: this.$t("result.motivators.groups.3")
        }
        if (this.motivators['h'] && this.motivators['h']['custom']) {
          keys[4] = this.$t("result.motivators.groups.4")
        }

        // skip if sharetopics false
        if (this.result_type === 1 || !this.shareTopics) {
          delete keys[2]
          delete keys[3]
        }
        return keys
      },
      isOdlisnostChecked() {
        return this.filter.includes(1)
      },
      itemBalance() {
        let ibal = {title: this.$t('result.motivators.population_match'), value: this.motivators.h.matchPercent}
        if (this.result_type === 1) {
          ibal.value =  this.motivators.h.work.statistic.matchPercent
        }else if (this.group.length === 1) {
          switch (this.group[0]) {
            case 1:
              ibal.value = this.motivators.h.work.statistic.matchPercent
              break;
            case 2:
              ibal.value = this.motivators.h.health.statistic.matchPercent
              break;
            case 3:
              ibal.value = this.motivators.h.family.statistic.matchPercent
              break;
            case 4:
              ibal.value = null
              break;
          }
        } else if (this.group.length > 1) {
          let values = 0
          if (this.group.includes(4)) { // custom => null
            ibal.value = null
          } else {
            if (this.group.length === 2) {
              for (let flt in this.group) {
                values += this.motivators.h[this.group_keys[this.group[flt]]].statistic.matchPercent
              }
              ibal.value = values / 2
            }
          }
        }

        return ibal
      },
      colors() {
        return this.$store.getters['app/colors']
      },
      showAll(){
        return this.$store.getters['diagnostic/showAll']
      },
      termsJoined() {
        return ResultUtils.termsJoined(this.motivators, this.shareTopics, this.result_type);
      }
    },
    methods: {
      getTermByLocale(term) {
        return ResultUtils.getTermByLocale(term, this.result.locale)
      },
      getTermFormat(term, current) {
        // let tf = {icons:[],scolor:null,shift:false,filters: [],groups: [0]}
        let tf = {icons:{},difference: null, scolor:null,shift:false,filters: [],groups: [0]}


        if (term.type === 'hr') {
          tf.filters.push(0)
        } else if (term.type === 'h') {
          tf.filters.push(0)
          //tf.icon = 'mdi-face'
        }

        let catKeys = {
          work: 1,
          health: 2,
          family: 3,
          custom: 4
        }
        tf.groups.push(catKeys[term.group])

        // kam to patri kdyz mimo
        let table_positions = {
          ideals: 1,
          satisfactors: 2,
          operators: 3,
          stresors: 4,
          destructors: 5
        }
        if (Math.abs(term.hMove) >= 2 && term.group !== 'custom') { //ignore custom
          let position = table_positions[current]
          let should_be = 0
          if (term.hMove) { // only H type
            should_be = position + term.hMove
          }
          tf.shift = true
          tf.scolor = this.colors[this.table_keys[should_be]+"Full"]
          tf.difference = {icon:'mdi-account-reactivate',color:this.colors[this.table_keys[should_be]+"Full"]}
          // tf.icons.push({icon:'mdi-account-reactivate',color:this.colors[this.table_keys[should_be]+"Full"]})
          tf.filters.push(1)
        } else if (term.type === 'hr' && Math.abs(term.hMove) < 2) {
          //tf.color = this.colors['match']
          //tf.icon='mdi-scale-balance'
          // remove SUNNY ICON motivator tf.icons.balance = {icon:'mdi-weather-sunny',color:null}
          tf.filters.push(2)
        }

        let dif = Math.abs(this.termsJoined.list[term.key]['h']) - Math.abs(this.termsJoined.list[term.key]['r'])
        if (dif >= 2) {
          // remove WAVE ICON motivator tf.icons.disbalance = { icon:'mdi-sawtooth-wave', color:null }
          tf.filters.push(3)
        }

        return tf
      }
    },
    created() {
      this.motivators = this.result.parameters.bmFull.motivation
    },
    watch: {
    }
  }
</script>
